<template>

  <b-modal
      id="send_signed_pro_modal"
      modal-class='form send_signed_pro_modal'
      modal-footer="hide"
      scrollable
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Envoyez vos PRO signés"
  >

    <div class="form form__addChallenge">
      <p>Souhaitez vous envoyer vos PRO signés à l'administrateur pour validation ?</p>
    </div>

    <template v-slot:modal-footer>
      <b-button
          class="btn-secondary"
          @click="closeMe()">
        Annuler
      </b-button>
      <b-button
          class="btn-primary"
          @click="sendPro()">
        Valider
      </b-button>
    </template>

  </b-modal>
</template>

<script>

export default {
  name: "SendSignedPro",
  methods:{
    onSubmit(evt) {
      evt.preventDefault()
    },
    onReset() {
      // Reset our form values
      this.form.other = null;
      this.form.participated = null;
    },
    //CLOSE THE POPUP
    closeMe(){
      this.$root.$emit('bv::hide::modal', 'send_signed_pro_modal');
    },
    sendPro() {
      this.$emit('send', true);
      this.$root.$emit('bv::hide::modal', 'send_signed_pro_modal');
    }
  },
}
</script>

